<ng-dialog-header title="Train Consist"></ng-dialog-header>
<mat-dialog-content>
  <div class="py-3">
    <div class="row">
      <div class="col text-center">
        <div><strong>Train</strong></div>
        <div>{{ trainConsist?.trainId }}</div>
      </div>
      <div class="col text-center">
        <div><strong>Current Location</strong></div>
        <div>{{ trainConsist?.currentLocation }}</div>
      </div>
      <div class="col text-center">
        <div><strong>Total Cars</strong></div>
        <div>{{ trainConsist?.totalCars }}</div>
      </div>
      <div class="col text-center">
        <div><strong>Latest Move Date</strong></div>
        <div>{{ trainConsist?.latestMoveDate | date:'MM/dd/yyyy hh:mm a' }}</div>
      </div>
      <div class="col text-center">
        <div><strong>Latest Crew Call</strong></div>
        <div>{{ trainConsist?.latestCrewCall | date:'MM/dd/yyyy hh:mm a' }}</div>
      </div>
    </div>
  </div>
  <div class="flex-grow-1">
    <ns-grid class="h-100"
             [name]="gridConfigurations.gridName"
             [columns]="gridConfigurations.columns"
             [data]="trainConsist?.historicalConsist || []"
             [loading]="loading"
             [gridOptions]="gridConfigurations.options"
             [config]="gridConfigurations.headerOptions">
    </ns-grid>
  </div>
</mat-dialog-content>
<ng-dialog-footer>
  <div dialog-actions class="d-flex justify-content-end w-100">
    <button mat-stroked-button color="warn" aria-label="close" mat-dialog-close>Close</button>
  </div>
</ng-dialog-footer>
